export default __webpack_public_path__ + "static/modtod-11a2d2702fa2c2780be28ce04f03e9c4.svg";